<template>
    <v-flex>
      <v-combobox v-model="computedModel"
                  dense
                  :error-messages="computedErrors"
                  item-text="name"
                  item-value="value"
                  :items="items"
                  :label="label"
                  :placeholder="placeholder"
                  @blur="handleBlur"
                  chips
                  multiple
                  return-object>
        <template slot="selection" slot-scope="{ item, parent }">
          <v-chip @click="(e) => e.stopPropagation()">
            <span>{{ item.name }}</span>
            <v-icon
              class="close-icon"
              @click="handleRemoveItem(item)"
              small
            >mdi-close-circle</v-icon>
          </v-chip>
        </template>
      </v-combobox>
    </v-flex>
  </template>
<script>
import { SERVICE_LOG } from '@/constants';
/* eslint-disable */

  export default {
    name: 'CheckboxList2',
    props: {
      items: {
        type: Array,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      placeholder: {
        type: String,
        required: true
      },
      resetId: {
        type: Boolean
      },
      validation: {
        required: false
      },
      values: {
        type: Array,
        default: () => { return [] }
      },
      index: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        selected: []
      };
    },
    computed: {
      computedModel: {
        get() {
          return this.selected;
        },
        set(values) {
          this.selected = values.map(
            (value) => {
              return typeof value === 'string' ? { value: SERVICE_LOG.CODES.OTHER, name: value, id: value.id } : value;
            }
          );
        }
      },
      computedErrors() {
        const errors = [];
        if (!this.validation.$dirty && this.validation) return errors;
        if (this.validation.required && (this.selected[0] === undefined || this.selected[0].value === '')) errors.push(`Implementation is required.`);
        /** TODO - TECH DEBT: Re-enable once ECSSS-23713 is settled */
        return errors;
      }
    },
    methods: {
      handleFormatChip(value) {
        return value === SERVICE_LOG.CODES.OTHER || value === null;
      },
      handleRemoveItem(item) {
        this.selected = this.selected.filter((existing) => { return existing.name !== item.name });
      },
      handleBlur() {
        this.validation.$touch();
      },
      // clear the selected array if the values array is empty
      // (if there are multiple students selected to create a SL)
      clearSelected() {
        if (this.values.length === 0 && this.selected.length > 0) this.selected = [];
      }
    },
    watch: {
      values: {
        handler() {
          this.clearSelected();
        },
        deep: true
      },
      selected: {
        handler() {
          this.$emit('update', this.selected);
        },
        deep: true
      }
    },
    mounted() {
      /**
       * On copy operations, API determines if value is new based on presence of id.
       * Iterate array, deserialize object, and overwrite id as null if action is copy.
       * */
      this.selected = this.resetId ? this.values.map((value) => { return { ...value, id: null } }) : this.values;
    }
  }
  </script>


  <style lang="scss" scoped>
    .other-chip {
      align-items:center;
      background: #e0e0e0;
      border-radius: 28px;
      display:flex;
      font-size: 13px;
      margin: 4px;
      padding: 0 12px;
      white-space: pre-wrap;
    };
    .other-content {
      float: left;
      max-width: 100%;
      padding-top: 7px;
      padding-bottom: 7px;
    };
    .close-icon {
      opacity: 50%;
      color: inherit;
      float: left;
      opacity: 50%;
      padding-left: 3px;
    }
  </style>



// WEBPACK FOOTER //
// src/components/base/checkbox-list-2.vue